/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Side_Not_Profile14Inputs */

const en_us2_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The side photo doesn't show your body in profile. For the side photo, turn sideways to the phone, one shoulder in front of the other.`)
};

const pt_br2_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foto de lado não mostra o corpo de perfil. Na foto de lado, vire de perfil para o celular, com um ombro na frente do outro.`)
};

const es_419_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La foto de lado no muestra tu cuerpo de perfil. Para la foto de lado, ponte de perfil frente al teléfono, con un hombro delante del otro.`)
};

const pt_pt2_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foto de lado não mostra o corpo de perfil. Na foto de lado, vira-te de perfil para o telemóvel, com um ombro à frente do outro.`)
};

const fr_fr2_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La photo de profil ne montre pas ton corps de profil. Pour celle-ci, mets-toi de côté face au téléphone, une épaule devant l'autre.`)
};

const de_de2_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Seitenfoto zeigt deinen Körper nicht im Profil. Dreh dich für das Seitenfoto seitlich zum Handy, eine Schulter vor der anderen.`)
};

const it_it2_body_assessment_error_side_not_profile14 = /** @type {(inputs: Body_Assessment_Error_Side_Not_Profile14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La foto laterale non mostra il corpo di profilo. Per la foto laterale, mettiti di profilo rispetto al telefono, con una spalla davanti all'altra.`)
};

/**
* | output |
* | --- |
* | "The side photo doesn't show your body in profile. For the side photo, turn sideways to the phone, one shoulder in front of the other." |
*
* @param {Body_Assessment_Error_Side_Not_Profile14Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_side_not_profile14 = /** @type {((inputs?: Body_Assessment_Error_Side_Not_Profile14Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Side_Not_Profile14Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_side_not_profile14(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_side_not_profile14(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_side_not_profile14(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_side_not_profile14(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_side_not_profile14(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_side_not_profile14(inputs)
	return en_us2_body_assessment_error_side_not_profile14(inputs)
});
export { body_assessment_error_side_not_profile14 as "body-assessment.error.SIDE_NOT_PROFILE" }